export const WM_ENVIRONMENT = "development"; // production
export const PASSWORD_LENGTH = 8;
// export const TOKEN_NAME = WM_ENVIRONMENT === 'development' ? 'dev_wmtoken' : 'wmtoken';
export const TOKEN_NAME =
  WM_ENVIRONMENT === "production" ? "wmtoken" : "dev_wmtoken";
export const IDENTITY = "wmhandler";
export const MAIN_URL =
  WM_ENVIRONMENT === "production"
    ? "https://wisemonkeys.info/"
    : "https://stage.wisemonkeys.info/";
